import { store } from '../../../lib/stores/store';
import { KeyValue } from '../../../lib/typegen/key-value';

export function handleReceiptOptions(pageParams: KeyValue[] | undefined | null): 'available' | 'not-available' | 'not-a-receipt-option' {
	if (!pageParams || pageParams.length === 0) return 'not-a-receipt-option';
	const receiptTypeString = pageParams.find((param) => param.key === 'receiptType')?.value;
	if (!receiptTypeString) return 'not-a-receipt-option';
	const receiptType = Number(receiptTypeString);
	if (Number.isNaN(receiptType)) return 'not-a-receipt-option';
	return (store.configStore.receiptOptionsAvailable & receiptType) !== 0 ? 'available' : 'not-available';
}
